// extracted by mini-css-extract-plugin
export default {"history-block":"GfVdY","history-block-load":"FAhC3"};